import { render, staticRenderFns } from "./QualityControlIndex.vue?vue&type=template&id=2bcf6eea"
import script from "./QualityControlIndex.vue?vue&type=script&lang=js"
export * from "./QualityControlIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports